module.exports = __webpack_public_path__ + "img/mindnet.213b1196.png";